import { Component, Inject, LOCALE_ID } from '@angular/core';
import { EnvironmentService, EnvironmentSettings } from 'src/app/core/services/environment/environment.service';
import { NavigationService } from 'src/app/core/services/navigation/navigation.service';
import { NgTemplateOutlet, NgClass, CommonModule } from '@angular/common';
import { MatDialogClose } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatRipple } from '@angular/material/core';

@Component({
    selector: 'qo-mobile-menu',
    templateUrl: './mobile-menu.component.html',
    imports: [CommonModule, NgTemplateOutlet, MatDialogClose, MatIcon, NgClass, MatRipple]
})
export class MobileMenuComponent {

    NavigationService = NavigationService;
    environmentSettings: EnvironmentSettings;

    displayResources: boolean = false;
    displayProducts: boolean = false;

    ressourcesAccreditationGuideLink: string = "https://blog.quick-off.com/2025/07/10/accreditation-evenementielle-et-controle-dacces-les-fondamentaux-pour-une-logistique-fluide-et-securisee-guide-gratuit/";
    ressourcesVolunteerStudyLink: string = "https://blog.quick-off.com/2025/04/10/etude-2025-sur-le-benevolat-evenementiel-chiffres-analyses-et-leviers-daction/";
    ressourcesVolunteeringLegalLink: string = "https://blog.quick-off.com/2024/10/14/nouveau-guide-benevolat-evenementiel-reperes-juridiques-et-bonnes-pratiques%f0%9f%93%96/";

    constructor(environmentService: EnvironmentService,
        @Inject(LOCALE_ID) public locale: string) {
        this.environmentSettings = environmentService.settings;
    }
}
